<template>
  <notification-base>
    <template #icon_start>
      <warning-icon class="w-6 h-6 text-[var(--primary-color)]" />
    </template>
    <template #content>
      <slot name="content">
        <div class="text-th-light-gray font-light text-sm tracking-wide">
          <slot name="content_upper_row" />
        </div>
        <div class="text-th-red">
          <slot name="content_lower_row" />
        </div>
      </slot>
    </template>
  </notification-base>
</template>

<script>
import NotificationBase from '../base'
import { WarningIcon } from '@shared/assets/icons'

export default {
  components: {
    NotificationBase,
    WarningIcon
  }
}
</script>
